export enum IntegrationCompany {
    Xero = 1,
    Crunch = 2,
    QuickBooks = 3,
    Google = 4,
    Facebook = 5,
    Apple = 6
}